export default "__VITE_ASSET__DrH5zmDJ__"